/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Back_To_LoginInputs */



/**
* | output |
* | --- |
* | "Back to Login" |
*
* @param {Auth_Verify_Back_To_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_back_to_login = /** @type {((inputs?: Auth_Verify_Back_To_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Back_To_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à la connexion")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver al inicio de sesión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar para o Login")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna all'Accesso")
	return /** @type {LocalizedString} */ ("Back to Login")
});